export default __webpack_public_path__ + "static/media/twitter.20a8ac16.svg";